import React from "react";
import styled from "styled-components";
import Heading from "../Heading";
import { RedButton, WhiteButton } from "../Button";
import CloseIcon from "../../images/Close.svg";
import { trackFinFormCancelButton, trackFinFormSaveButton } from "../../DumbleData";

interface Props {
	saveAndPublish?(): any;
	discardChanges?(): any;
    setModalIsOpen: any;
	modalIsOpen: boolean;
	handleModal?(): any;
	language: string;
}

const SaveChangesModal = ({
	saveAndPublish,
	discardChanges,
    setModalIsOpen,
	modalIsOpen,
	language
}: Props) => {

    const handleSaveChanges = () => {
        trackFinFormSaveButton();
        if (saveAndPublish) {saveAndPublish();}
    }

    const handleCancelChanges = () => {
        trackFinFormCancelButton();
        setModalIsOpen(false);
    }

	return (<>
        {modalIsOpen && (
            <>
                <Modal>
                    <StyledClose onClick={() => setModalIsOpen(false)}>
                        <img src={CloseIcon} alt="Close"/>
                    </StyledClose>
                    <StyledHeading>{language === "en" ? "Do you want to save?" : "Souhaitez-vous sauvegarder?"}</StyledHeading>
                    <StyledRedButton handleClick={handleSaveChanges}>
                        {language === "en" ? "Save" : "Sauvegarder"}</StyledRedButton>
                    <StyledWhiteButton handleClick={handleCancelChanges}>
                        {language === "en" ? "Cancel": "Annuler"}
                    </StyledWhiteButton>
                </Modal>
                <ModalOverlay></ModalOverlay>
            </>
        )}
    </>);
};

export default SaveChangesModal;

const Modal = styled.div`
    box-sizing: border-box;
    position: fixed;
    background-color: white;
    top: 30px;
    width: 50%;
    margin-left: 25%;
    text-align: center;
    padding: 16px 16px 44px 16px;
    z-index: 1001;
    border-radius: 8px;
    box-shadow: 0px 7px 14px 0px rgba(0, 0, 0, 0.20);
    @media (max-width: 719px) {
        top: 60px;
        width: calc(100% - 40px);
        margin: 0 20px;
    }
`;

const StyledClose = styled.button`
    position: absolute;
    right: 16px;
    background: none;
    border: none;
    cursor: pointer;
    img {
        height: 16px;
        width: 16px;
    }
`

const StyledHeading = styled(Heading)`
    margin-bottom: 60px;
    color: #333;
    font-size: 28px;
    font-weight: 300;
    line-height: 32px;
    padding-top: 28px;
    @media (max-width: 719px) { 
        margin-bottom: 38px;
    }
`;

const StyledRedButton = styled(RedButton)`
    width: 157px;
    margin-right: 32px;
    @media (max-width: 719px) {        
        display: block;
        width: 132px;
        margin: 0 auto 32px auto;
    }
`

const StyledWhiteButton = styled(WhiteButton)`
    color: #333;
    &: hover {
        color: #333;
    }
`

const ModalOverlay = styled.div`
    position: fixed;
    background: rgba(0, 0, 0, 0.48);
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
`;